import React from "react";
import { Tab, Tabs } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useDispatch } from "react-redux";
import { cierraMenuActivo } from "../../redux/slices/menuSlice";

const TabsPages = ({ items, onMenuActivo, menuActivo }) => {
  const dispatch = useDispatch();

  const handleCierraMenu = (menu) => {
    dispatch(cierraMenuActivo(menu));
  };

  const renderCloseIcon = (item) => {
    if (Object.keys(item).includes("closeable")) {
      if (item.closeable === true) {
        return (
          <CloseRoundedIcon
            sx={{ fontSize: 14 }}
            onClick={() => handleCierraMenu(item)}
          />
        );
      } else {
        return null;
      }
    }

    return (
      <CloseRoundedIcon
        sx={{ fontSize: 14 }}
        onClick={() => handleCierraMenu(item)}
      />
    );
  };

  return (
    <Tabs
      value={menuActivo?.idMenu}
      onChange={(e, menu) => onMenuActivo(menu)}
      variant="scrollable"
      scrollButtons="auto"
      aria-label="Páginas abiertas"
      indicatorColor="primary"
      sx={{
        minHeight: 8,
        backgroundColor: 'background.paper'
      }}
    >
      {items?.map((i) => (
        <Tab
          key={i.idMenu}
          label={i.nombre}
          value={i.idMenu}
          sx={{
            minHeight: 8,
          }}
          icon={renderCloseIcon(i)}
          iconPosition="end"
        />
      ))}
    </Tabs>
  );
};
export default TabsPages;
